import React, { useState, useRef, useEffect } from 'react';
import './PageMenu.scss';
import { PageDetails } from './Session';
import { ReactComponent as MenuIcon } from '../assets/format_list_bulleted_large.svg';
import { ReactComponent as CloseIcon } from '../assets/close.svg';

export interface PageMenuProps {
  pages: PageDetails[];
  selectedPageIndex: number | null | undefined;
  selectPage: (pageIndex: number) => void;
  autoSelectLatest: boolean;
}

const PageMenu: React.FC<PageMenuProps> = ({
  pages,
  selectedPageIndex,
  selectPage,
  autoSelectLatest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const firstFocusableElement = useRef<HTMLButtonElement>(null);
  const closedFocusableElement = useRef<HTMLButtonElement>(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const select = (pageIndex: number) => {
    selectPage(pageIndex);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen && closedFocusableElement.current) {
      closedFocusableElement.current.blur();
    }
  }, [isOpen]);

  return (
    <div className="menu">
      <button
        className="menu-icon"
        onClick={toggleMenu}
        ref={closedFocusableElement}
      >
        <MenuIcon />
      </button>
      <>
        {isOpen && <div className="menu-backdrop" onClick={toggleMenu}></div>}
        <div
          className={`menu-list ${isOpen && 'open'}`}
          aria-hidden={!isOpen} /* Hides it from screen readers */
        >
          <button
            onClick={toggleMenu}
            className="close-button"
            title="close"
            ref={firstFocusableElement}
          >
            <CloseIcon />
          </button>
          <ul>
            {pages.map((p, i) => (
              <li
                className={`${i === selectedPageIndex || (autoSelectLatest && selectedPageIndex === -1 && i === pages.length - 1) ? 'active' : ''}`}
                key={i}
                tabIndex={0}
                onClick={() => select(i)}
                role="button"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    select(i);
                  }
                }}
              >
                {i + 1}. {p.name}
              </li>
            ))}
          </ul>
        </div>
      </>
    </div>
  );
};

export default PageMenu;
